import { GetInitialDataCtx, WidgetProps } from "../../contracts/widget"
import { bookingWidgetConfig, BookingWidgetConfig } from "./config"
import { WidgetProvider } from "../../providers/widget"
import BookingWidgetContent from "./components/BookingWidgetContent"
import "./booking.css"
import { useMemo } from "react"
import { parseWidgetConfig } from "@homerunner-next/widget-core/schema"

export const getInitialData = async ({ options, feedId, widgetId }: GetInitialDataCtx<BookingWidgetConfig>) => {
    return {}
}

export default function BookingWidget({ options, feedId, widgetId, resolvedTheme, data }: WidgetProps<BookingWidgetConfig>) {
    const parsedOptions = useMemo(() => parseWidgetConfig(bookingWidgetConfig, options), [options])
    return (
        <WidgetProvider options={parsedOptions} feedId={feedId} widgetId={widgetId} resolvedTheme={resolvedTheme} widgetType="booking" data={data ?? {}}>
            <BookingWidgetContent />
        </WidgetProvider>
    )
}
